import { Component, Vue, Prop } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faCheckCircle);

@Component({
	components: {
	},
})
export default class InputPortal extends Vue {
	@Prop({ default: 'Salvo com sucesso.' }) readonly text;
}
